import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityDataAccessSearchUser } from '@api/data-security';

export const getCoreDataSecurityDataAccessSearchUserSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityDataAccessSearchUser',
	receive: true,
	request: true,
	requestHandler: getDataSecurityDataAccessSearchUser,
	retainDataOnRequest: true
});
